/* RMS 2026-09-24 · adet secicisini fiyatin yanina tasir.
   Gerekce ve olcumler: src/rms/mobil-sigdir.mjs */
(function () {
  'use strict';

  function tasi() {
    if (document.querySelector('.rms-fiyat-satir')) return;
    var fiyat = document.querySelector('.rms-fiyat');
    var adet = document.querySelector('.product-form__quantity');
    if (!fiyat || !adet) return;
    var s = document.createElement('div');
    s.className = 'rms-fiyat-satir';
    fiyat.parentElement.insertBefore(s, fiyat);
    s.appendChild(fiyat);
    s.appendChild(adet);
  }

  function baslat() {
    tasi();
    // Tema varyant degisiminde bolumu yeniden cizebiliyor; kisa sure izle.
    var n = 0;
    var t = setInterval(function () { tasi(); if (++n > 20) clearInterval(t); }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', baslat);
  } else {
    baslat();
  }
})();
